import { Skeleton } from 'primereact/skeleton';
const SideBarMenuSkeleton=()=>{
    return(
        <>
            {/* <div className='sidebar-menu'> */}
                <div className='menu-skeleton-item'>
                    <Skeleton shape="circle" size="2rem" className="mr-2" borderRadius="2rem"></Skeleton>
                    <Skeleton width="40%"></Skeleton>
                </div>
                <div className='menu-skeleton-item'>
                    <Skeleton shape="circle" size="2rem" className="mr-2" borderRadius="2rem"></Skeleton>
                    <Skeleton width="60%"></Skeleton>
                </div>
                <div className='menu-skeleton-item'>
                    <Skeleton shape="circle" size="2rem" className="mr-2" borderRadius="2rem"></Skeleton>
                    <Skeleton width="70%"></Skeleton>
                </div>
                <div className='menu-skeleton-item'>
                    <Skeleton shape="circle" size="2rem" className="mr-2" borderRadius="2rem"></Skeleton>
                    <Skeleton width="40%"></Skeleton>
                </div>
                <div className='menu-skeleton-item'>
                    <Skeleton shape="circle" size="2rem" className="mr-2" borderRadius="2rem"></Skeleton>
                    <Skeleton width="60%"></Skeleton>
                </div>
                <div className='menu-skeleton-item'>
                    <Skeleton shape="circle" size="2rem" className="mr-2" borderRadius="2rem"></Skeleton>
                    <Skeleton width="30%"></Skeleton>
                </div>
            {/* </div> */}
        </>
    )
}
export default SideBarMenuSkeleton;